export const RoleContentEnum = Object.freeze({
  GAMEDAY_EXTERNAL_ADMIN: '"A"',
  GAMEDAY_INTERNAL_ADMIN: '"IA"',
  GAMEDAY_INVOICE_ONLY: '"I"',
  GAMEDAY_VIEW_ONLY: '"V"',
  GAMEDAY_PRODUCTION_SUPPORT: '"P"',
  GAMEDAY_STANDARD_USER: '"S"',
  GAMEDAY_SUPER_USER: '"SU"'
});
